<template>
    <span>
        <!-- Menú lateral que aparece sólo cuando drawer == true, siendo ésto posible sólo en ventanas sm y menores: -->
        <v-navigation-drawer
            app
            v-model="drawer"
            class="grey lighten-5"
            disable-resize-watcher
            v-if="isAuthenticated"
        >
            <!-- Menú visible si no se ha iniciado sesión: -->
            <!-- <v-list v-if="!isAuthenticated" dense class="pt-0">
                <v-list-item class="tw-green" @click="onQueEvaluamos">
                    <v-list-item-action>
                        <v-icon color="teal darken-1">mdi-chart-line</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>{{
                            $t('menu-que-evaluamos')
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item class="tw-green" @click="onComoFunciona">
                    <v-list-item-action>
                        <v-icon color="teal darken-1">mdi-cogs</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title color="teal darken-3">{{
                            $t('menu-como-funciona')
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item class="tw-green" @click="onCaracteristicas">
                    <v-list-item-action>
                        <v-icon color="teal darken-1">mdi-file-document</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>{{
                            $t('menu-caracteristicas')
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item class="tw-green" @click="onGuiaInterpretacion">
                    <v-list-item-action>
                        <v-icon color="teal darken-1">mdi-teach</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>{{
                            $t('menu-guia')
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item class="tw-green" @click="onContacto">
                    <v-list-item-action>
                        <v-icon color="teal darken-1">mdi-information</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>{{
                            $t('menu-contacto')
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list> -->
            <!-- Fin del menú visible si no se ha iniciado sesión -->

            <v-list v-if="isAuthenticated" dense class="pt-0">
                <v-list-item
                    v-if="userType === 1"
                    class="tw-green"
                    @click="onCompanies"
                >
                    <v-list-item-action>
                        <v-icon color="teal darken-1">mdi-domain</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Empresas</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item
                    v-if="userType === 1"
                    class="tw-green"
                    @click="onUsers"
                >
                    <v-list-item-action>
                        <v-icon color="teal darken-1"
                            >mdi-account-multiple</v-icon
                        >
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Usuarios</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item
                    v-if="userType === 1 || userType === 2 || userType === 3"
                    class="tw-green"
                    @click="onEncuestas"
                >
                    <v-list-item-action>
                        <v-icon color="teal darken-1"
                            >mdi-clipboard-pulse-outline</v-icon
                        >
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Encuestas</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-divider v-if="userType === 1"></v-divider>

                <v-list-item
                    v-if="userType === 1"
                    class="tw-green"
                    @click="onIdiomas"
                >
                    <v-list-item-action>
                        <v-icon color="teal darken-1">mdi-earth</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Idiomas</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item
                    v-if="userType === 1"
                    class="tw-green"
                    @click="onRespuestas"
                >
                    <v-list-item-action>
                        <v-icon color="teal darken-1">mdi-check-all</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title
                            >Sets de Respuestas</v-list-item-title
                        >
                    </v-list-item-content>
                </v-list-item>

                <v-list-item
                    v-if="userType === 1"
                    class="tw-green"
                    @click="onCuestionarios"
                >
                    <v-list-item-action>
                        <v-icon color="teal darken-1"
                            >mdi-clipboard-list-outline</v-icon
                        >
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Cuestionarios</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>

                <v-list-item
                    v-if="userType === 1"
                    class="tw-green"
                    @click="onBusqueda"
                    color="teal darken-1"
                >
                    <v-list-item-action>
                        <v-icon color="teal darken-1">mdi-magnify</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title color="teal darken-1"
                            >Búsqueda</v-list-item-title
                        >
                    </v-list-item-content>
                </v-list-item>

                <v-list-item
                    v-if="userType === 1"
                    class="tw-green"
                    @click="onReportesEspeciales"
                    color="teal darken-1"
                >
                    <v-list-item-action>
                        <v-icon color="teal darken-1"
                            >mdi-file-table-outline</v-icon
                        >
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title color="teal darken-1"
                            >Reportes Especiales</v-list-item-title
                        >
                    </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>

                <v-list-item
                    class="tw-green"
                    @click="onLogout"
                    color="teal darken-1"
                >
                    <v-list-item-action>
                        <v-icon color="teal darken-1">mdi-exit-to-app</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title color="teal darken-1"
                            >Salir</v-list-item-title
                        >
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
        <!-- Termina menú lateral para dispositivos con ventanas sm y menores-->

        <v-app-bar flat fixed app color="grey lighten-5" clipped-left>
            <v-app-bar-nav-icon
                class="hidden-md-and-up"
                @click="drawer = !drawer"
                v-if="isAuthenticated"
            ></v-app-bar-nav-icon>

            <img
                height="55"
                :src="mainLogo"
                @click="onHome"
                class="logo-hover"
            />

            <v-toolbar-title
                v-if="isAuthenticated && userType === 1"
                class="hidden-sm-and-down"
            >
                <div class="tw-green title">&nbsp; {{ userName }}</div>
            </v-toolbar-title>
            <v-toolbar-title
                v-else-if="
                    isAuthenticated &&
                    (userType === 1 || userType === 2 || userType === 3)
                "
                class="hidden-sm-and-down"
            >
                <div class="tw-green title">
                    {{ userName }} - {{ companyName }}
                </div>
            </v-toolbar-title>

            <v-toolbar-title
                v-if="isAuthenticated && userType === 1"
                class="hidden-md-and-up"
            >
                <div class="tw-green subtitle-1">{{ userName }}</div>
            </v-toolbar-title>
            <v-toolbar-title
                v-if="isAuthenticated && userType !== 1"
                class="hidden-md-and-up"
            >
                <div class="tw-green subtitle-1">
                    {{ userName }} - {{ companyName }}
                </div>
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <!-- Menú visible si no se ha iniciado sesión: -->
            <!-- <v-toolbar-items v-if="!isAuthenticated" class="hidden-sm-and-down">
                <v-btn
                    text
                    class="text-none"
                    color="teal darken-3"
                    @click="onQueEvaluamos"
                    >{{ $t('menu-que-evaluamos') }}</v-btn
                >
                <v-btn
                    text
                    class="text-none"
                    color="teal darken-3"
                    @click="onComoFunciona"
                    >{{ $t('menu-como-funciona') }}</v-btn
                >
                <v-btn
                    text
                    class="text-none"
                    color="teal darken-3"
                    @click="onCaracteristicas"
                    >{{ $t('menu-caracteristicas') }}</v-btn
                >
                <v-btn
                    text
                    class="text-none"
                    color="teal darken-3"
                    @click="onGuiaInterpretacion"
                    >{{ $t('menu-guia') }}</v-btn
                >
                <v-btn
                    text
                    class="text-none"
                    color="teal darken-3"
                    @click="onContacto"
                    >{{ $t('menu-contacto') }}</v-btn
                >
            </v-toolbar-items> -->
            <!-- Fin del menú visible si no se ha iniciado sesión -->

            <v-toolbar-items v-if="isAuthenticated" class="hidden-sm-and-down">
                <v-menu v-if="userType === 1" offset-y>
                    <template v-slot:activator="{ on }">
                        <v-btn
                            color="teal darken-3"
                            text
                            class="text-none"
                            v-on="on"
                            >Administración</v-btn
                        >
                    </template>
                    <v-list color="grey lighten-5">
                        <v-list-item v-if="userType === 1" @click="onCompanies">
                            <v-list-item-title>
                                <v-icon color="teal darken-1">mdi-domain</v-icon
                                >&nbsp; Empresas
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item v-if="userType === 1" @click="onUsers">
                            <v-list-item-title>
                                <v-icon color="teal darken-1"
                                    >mdi-account-multiple</v-icon
                                >&nbsp; Usuarios
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item @click="onEncuestas">
                            <v-list-item-title>
                                <v-icon color="teal darken-1"
                                    >mdi-clipboard-pulse-outline</v-icon
                                >&nbsp; Encuestas
                            </v-list-item-title>
                        </v-list-item>

                        <v-divider v-if="userType === 1"></v-divider>

                        <v-list-item v-if="userType === 1" @click="onIdiomas">
                            <v-list-item-title>
                                <v-icon color="teal darken-1">mdi-earth</v-icon
                                >&nbsp; Idiomas
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            v-if="userType === 1"
                            @click="onRespuestas"
                        >
                            <v-list-item-title>
                                <v-icon color="teal darken-1"
                                    >mdi-check-all</v-icon
                                >&nbsp; Sets de Respuestas
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            v-if="userType === 1"
                            @click="onCuestionarios"
                        >
                            <v-list-item-title>
                                <v-icon color="teal darken-1"
                                    >mdi-clipboard-list-outline</v-icon
                                >&nbsp; Cuestionarios
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <v-btn
                    v-if="userType === 1"
                    color="teal darken-3"
                    text
                    class="text-none"
                    @click="onBusqueda"
                    >Búsqueda</v-btn
                >
                <v-btn
                    v-if="userType === 1"
                    color="teal darken-3"
                    text
                    class="text-none"
                    @click="onReportesEspeciales"
                    >Reportes Especiales</v-btn
                >
                <v-btn
                    v-if="userType === 2 || userType === 3"
                    color="teal darken-3"
                    text
                    class="text-none"
                    @click="onEncuestas"
                >
                    <v-icon color="teal darken-1"
                        >mdi-clipboard-pulse-outline</v-icon
                    >&nbsp; Encuestas
                </v-btn>
                <v-btn
                    color="teal darken-3"
                    text
                    class="text-none"
                    @click="onLogout"
                    >Salir</v-btn
                >
            </v-toolbar-items>
            <!-- Fin del menú visible si se inició sesión -->

            <!-- El select para cambiar idioma aparece si no se está logueado o si el usuario logueado no es encuestado: -->
            <!-- <v-toolbar-items
                v-if="!isAuthenticated || (isAuthenticated && userType !== 4)"
            >
                <locale-changer></locale-changer>
            </v-toolbar-items> -->

            <img
                height="65"
                :src="efectividadOrganizacionalLogo"
                @click="onHome"
                class="logo-hover"
            />
        </v-app-bar>

        <v-overlay :value="overlay">
            <v-btn icon @click="overlay = false">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-overlay>
    </span>
</template>

<script>
import { mapGetters } from 'vuex';
import LocaleChanger from '@/components/LocaleChanger';

export default {
    name: 'AppNavigation',
    data() {
        return {
            drawer: false,
            overlay: false,
            //valid: false
            //     e1: true,
            //     password: '',
            //     passwordRules: [v => !!v || 'Introduzca la contraseña'],
            //     email: '',
            //     emailRules: [
            //         v => !!v || 'Introduzca su correo electrónico',
            //         v =>
            //             /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
            //             'Introduzca un correo válido'
            //     ],
        };
    },
    components: {
        LocaleChanger,
    },
    methods: {
        onHome() {
            if (!this.isAuthenticated) {
                this.showQueEvaluamosTxt = false;
                this.showComoFuncionaTxt = false;
                this.showCaracteristicasTxt = false;
                this.showGuiaInterpretacionTxt = false;
                this.showContactoTxt = false;
                this.drawer = false;
            }
        },
        onQueEvaluamos() {
            this.showQueEvaluamosTxt = true;
            this.showComoFuncionaTxt = false;
            this.showCaracteristicasTxt = false;
            this.showGuiaInterpretacionTxt = false;
            this.showContactoTxt = false;
            this.drawer = false;
        },
        onComoFunciona() {
            console.log('onComoFunciona');
            this.showQueEvaluamosTxt = false;
            this.showComoFuncionaTxt = true;
            this.showCaracteristicasTxt = false;
            this.showGuiaInterpretacionTxt = false;
            this.showContactoTxt = false;
            this.drawer = false;
        },
        onCaracteristicas() {
            this.showQueEvaluamosTxt = false;
            this.showComoFuncionaTxt = false;
            this.showCaracteristicasTxt = true;
            this.showGuiaInterpretacionTxt = false;
            this.showContactoTxt = false;
            this.drawer = false;
        },
        onGuiaInterpretacion() {
            this.showQueEvaluamosTxt = false;
            this.showComoFuncionaTxt = false;
            this.showCaracteristicasTxt = false;
            this.showGuiaInterpretacionTxt = true;
            this.showContactoTxt = false;
            this.drawer = false;
        },
        onContacto() {
            this.showQueEvaluamosTxt = false;
            this.showComoFuncionaTxt = false;
            this.showCaracteristicasTxt = false;
            this.showGuiaInterpretacionTxt = false;
            this.showContactoTxt = true;
            this.drawer = false;
        },

        onCompanies() {
            this.$router.push('/companies');
            this.drawer = false;
        },
        onUsers() {
            this.$router.push('/users');
            this.drawer = false;
        },
        onIdiomas() {
            this.$router.push('/languages');
            this.drawer = false;
        },
        onRespuestas() {
            this.$router.push('/answersets');
            this.drawer = false;
        },
        onCuestionarios() {
            this.$router.push('/questionnaires');
            this.drawer = false;
        },
        onEncuestas() {
            this.$router.push('/surveys');
            this.drawer = false;
        },
        onAdministrators() {
            this.$router.push('/administrators');
        },
        onLogout() {
            //console.log('logout');
            //this.overlay = true;
            this.$store.dispatch('logout');
            this.drawer = false;
        },

        onBusqueda() {
            this.$router.push('/busqueda');
            this.drawer = false;
        },
        onReportesEspeciales() {
            this.drawer = false;
        },
    },
    computed: {
        ...mapGetters([
            'appTitle',
            'mainLogo',
            'mainLogoAppBar',
            'efectividadOrganizacionalLogo',
            'isAuthenticated',
            'userName',
            'company',
            'userType',
        ]),
        showQueEvaluamosTxt: {
            get() {
                return this.$store.getters.showQueEvaluamosTxt;
            },
            set(showQueEvaluamosTxt) {
                this.$store.dispatch(
                    'updateShowQueEvaluamosTxt',
                    showQueEvaluamosTxt
                );
            },
        },
        showComoFuncionaTxt: {
            get() {
                return this.$store.getters.showComoFuncionaTxt;
            },
            set(showComoFuncionaTxt) {
                this.$store.dispatch(
                    'updateShowComoFuncionaTxt',
                    showComoFuncionaTxt
                );
            },
        },
        showCaracteristicasTxt: {
            get() {
                return this.$store.getters.showCaracteristicasTxt;
            },
            set(showCaracteristicasTxt) {
                this.$store.dispatch(
                    'updateShowCaracteristicasTxt',
                    showCaracteristicasTxt
                );
            },
        },
        showGuiaInterpretacionTxt: {
            get() {
                return this.$store.getters.showGuiaInterpretacionTxt;
            },
            set(showGuiaInterpretacionTxt) {
                this.$store.dispatch(
                    'updateShowGuiaInterpretacionTxt',
                    showGuiaInterpretacionTxt
                );
            },
        },
        showContactoTxt: {
            get() {
                return this.$store.getters.showContactoTxt;
            },
            set(showContactoTxt) {
                this.$store.dispatch('updateShowContactoTxt', showContactoTxt);
            },
        },
        companyName() {
            var name = '';
            if (this.company !== null) {
                name = this.company.empresanombre;
            }
            return name;
        },
    },
};
</script>

<style scoped>
h5 {
    /* color: 'teal darken-1'; */
    color: #00897b;
}

.logo-hover:hover {
    cursor: pointer;
}

.usr-name {
    font-size: 14px;
    color: #00897b;
}

.tw-green {
    color: #00897b;
}

.tw-gray {
    /* color: #757575; */
    /* grey darken-1 */
    color: red;
}
</style>
